import axios from "axios";
export const API_URL = "/api/v1";
export const CONTACT_URL = API_URL+"/contact_board/";
export const GET_COMPANY_URL = API_URL+"/contract/get_company_list";
export const GET_TREATMENT_COMPANY_URL = API_URL+"/contract/get_treatment_company_list";
export const GET_MY_TREATMENT_COMPANY_URL = API_URL+"/contract_company_group/my_company_contracted_company_unique/";


export function saveContactData(data) {
  return axios.post(CONTACT_URL, data);
}

export function getCompanyList() {
  return axios.get(GET_COMPANY_URL);
}

export function getTreatmentCompanyList(contract_id) {
  return axios.get(GET_TREATMENT_COMPANY_URL + '?contract_id=' + contract_id);
}

export function getMyTreatmentCompanyList() {
  return axios.get(GET_MY_TREATMENT_COMPANY_URL + '?company_type=treatment');
}

export function getMyEmitterCompanyList() {
  return axios.get(GET_MY_TREATMENT_COMPANY_URL + '?company_type=emitter');
}
